




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ReductionPO from "@/store/entities/finance/reductionpo";

@Component({
  components: {},
})
export default class Reduction extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Array, default: [] }) chooseId: Array<any>;
  reduction: ReductionPO = new ReductionPO();
  loading: boolean = false;
  display: boolean = true; //支付条码是否显示

  create() {}
  created() {
    this.reduction.billsId = [];
    this.reduction.isRatio = 1;
    this.reduction.reductionTotal = 0;
    this.reduction.reductionType = 1;
  }
  save() {
    (this.$refs.itemForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        let res = await this.$store
          .dispatch({
            type: "bills/reductionbill",
            data: this.reduction,
          })
          .catch((err) => {
            this.loading = false;
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
          });
        this.$Modal.info({
          title: this.L("Tips"),
          content: res.data.result,
        });
        this.loading = false;
        (this.$refs.itemForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.itemForm as any).resetFields();
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
    }
  }
  itemRule = {
    baseUse: [
      {
        required: true,
        type: "number",
        message: this.L("Value") + this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  changeRadio(val) {
    if (val == 1) {
      this.display = false;      
      this.reduction.isRatio = 1;
    } else {
      this.display = true;
      this.reduction.isRatio =2;
    }
  }
  data() {
    return {
      paymentType: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
  @Watch("chooseId")
  getitemId() {
    this.reduction.billsId = this.chooseId;
  }
}
